import { useGetNetworkAdminsQuery } from 'services/networkAdminV2';
import { useSelector } from 'react-redux';
import { userSelector, activeNetworkSelector } from 'redux/selectors';

import { useGetIntroRequestsQuery, useGetSharedListsQuery } from 'services/organizationsV2';

export const useNetworkOverview = () => {
  const activeNetwork = useSelector(activeNetworkSelector);
  const user = useSelector(userSelector);

  const { networkAdminsCount, alliesCount, isLoading } = useGetNetworkAdminsQuery(
    { networkId: activeNetwork.id, includeAllies: true },
    {
      selectFromResult: ({ data }) => ({
        networkAdminsCount: data?.filter((admin) => admin.role === 'network_admin').length ?? 0,
        alliesCount:
          data?.filter((admin) => admin.role === 'ally' && admin.linkedinSyncStatus === 'active').length ?? 0,
      }),
    },
  );

  const { data: introRequests } = useGetIntroRequestsQuery(activeNetwork.id);
  const { data: sharedLists } = useGetSharedListsQuery(activeNetwork.id);

  const desktopWidth = '1/3';

  return {
    networkAdminsCount,
    alliesCount,
    isLoading,
    contactsCount: activeNetwork?.contactsTotal ?? 0,
    isLoadingContacts: false,
    activeNetwork,
    desktopWidth,
    introRequests,
    sharedLists,
    sharedListsCount: sharedLists?.total ?? 0,
    requestIntrosCount: introRequests?.total ?? 0,
    user,
  };
};
